import { useState, useEffect } from "react";
import { LayoutDashboard, Calendar, MessageSquare, GanttChart, Users, Zap, FileText, FolderKanban, ClipboardList, Plus } from "lucide-react";
import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandSeparator } from "@/components/ui/command";

const NAV_ACTIONS = [
  { label: "Go to Board", view: "board", icon: ClipboardList },
  { label: "Go to Dashboard", view: "dashboard", icon: LayoutDashboard },
  { label: "Go to Calendar", view: "calendar", icon: Calendar },
  { label: "Go to Team Chat", view: "chat", icon: MessageSquare },
  { label: "Go to Timeline", view: "gantt", icon: GanttChart },
  { label: "Go to Teams", view: "teams", icon: Users },
  { label: "Go to Automations", view: "automations", icon: Zap },
  { label: "Go to Templates", view: "templates", icon: FileText },
];

export const CommandPalette = ({ tasks, projects, onOpenTask, onSelectProject, onChangeView, onNewTask }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const down = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setOpen((o) => !o);
      }
    };
    window.addEventListener("keydown", down);
    return () => window.removeEventListener("keydown", down);
  }, []);

  const run = (fn) => { setOpen(false); fn(); };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Search tasks, projects, or jump to a view…" data-testid="command-palette-input" />
      <CommandList data-testid="command-palette-list">
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup heading="Actions">
          <CommandItem onSelect={() => run(onNewTask)} data-testid="cmd-new-task"><Plus className="h-4 w-4 mr-2" />New Task</CommandItem>
          {NAV_ACTIONS.map((a) => (
            <CommandItem key={a.view} onSelect={() => run(() => onChangeView(a.view))} data-testid={`cmd-nav-${a.view}`}>
              <a.icon className="h-4 w-4 mr-2" />{a.label}
            </CommandItem>
          ))}
        </CommandGroup>
        {projects?.length > 0 && (
          <>
            <CommandSeparator />
            <CommandGroup heading="Projects">
              {projects.slice(0, 8).map((p) => (
                <CommandItem key={p.id} value={`project ${p.name}`} onSelect={() => run(() => onSelectProject(p.id))} data-testid={`cmd-project-${p.id}`}>
                  <FolderKanban className="h-4 w-4 mr-2" />{p.name}
                </CommandItem>
              ))}
            </CommandGroup>
          </>
        )}
        {tasks?.length > 0 && (
          <>
            <CommandSeparator />
            <CommandGroup heading="Tasks">
              {tasks.slice(0, 30).map((t) => (
                <CommandItem key={t.id} value={`task ${t.title}`} onSelect={() => run(() => onOpenTask(t))} data-testid={`cmd-task-${t.id}`}>
                  <ClipboardList className="h-4 w-4 mr-2 opacity-60" />
                  <span className={t.completed ? "line-through opacity-60" : ""}>{t.title}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </>
        )}
      </CommandList>
    </CommandDialog>
  );
};
